import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";  // Імпорт іконок
import { useTranslation } from 'react-i18next';


const UsersTab = ({ users, fetchUsers }) => {
  const { t } = useTranslation();

  const [editModal, setEditModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [userData, setUserData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    role: "user",
  });
  const [errors, setErrors] = useState({});

  const sortedUsers = [...users].sort((a, b) => {
    if (!sortConfig.key) return 0;
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? 1 : -1;
    }
    return 0;
  });

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const validateFields = () => {
    let newErrors = {};
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email.trim())) {
      newErrors.email = t("emailWarning");
    }
    if (!/^[A-Za-z]+$/.test(userData.firstName.trim())) {
      newErrors.firstName = t("nameWarning");
    }
    if (!/^[A-Za-z]+$/.test(userData.lastName.trim())) {
      newErrors.lastName = t("surnameWarning");
    }
    if (!/^\+48\d{9}$/.test(userData.phone)) {
      newErrors.phone = t("phoneWarning");
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEditClick = (user) => {
    setSelectedUser(user);
    setUserData({
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      phone: user.phone,
      role: user.role || "user",
    });
    setErrors({});
    setEditModal(true);
  };

  const handleUpdate = async () => {
    if (!validateFields()) {
      alert(t("errorsWarning"));
      return;
    }
    try {
      await axios.put(`https://godrive.com.pl/api/userUpdate/${selectedUser.id}`, userData);
      fetchUsers();
      setEditModal(false);
    } catch (error) {
      console.error("Помилка оновлення користувача:", error);
    }
  };

  const handleResetPassword = async (userId) => {
    const generateRandomPassword = () => {
      const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
      let password = "";
      for (let i = 0; i < 10; i++) {
        password += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return password;
    };
  
    const newPassword = generateRandomPassword(); // Генеруємо випадковий пароль
  
    if (!window.confirm(`Новий пароль: ${newPassword}\nСкинути пароль?`)) {
      return;
    }
  
    try {
      const response = await axios.put(`https://godrive.com.pl/api/userResetPassword/${userId}`, {
        password: newPassword,
      });
  
      alert(`Пароль успішно скинуто! Новий пароль: ${newPassword}`);
    } catch (error) {
      console.error("Помилка скидання пароля:", error);
      alert("Не вдалося скинути пароль. Спробуйте ще раз.");
    }
  };

  const handleDeleteUser = async (userId) => {
    if (!window.confirm("Ви впевнені, що хочете видалити цього користувача? Цю дію не можна скасувати!")) {
      return;
    }

    try {
      await axios.delete(`https://godrive.com.pl/api/deleteUser/${userId}`);
      fetchUsers();
    } catch (error) {
      console.error("Помилка видалення користувача:", error);
      alert("Не вдалося видалити користувача. Спробуйте ще раз.");
    }
  };

  

  return (
    <div>
      <h4>{t("usersList")}</h4>
      <table className="table table-striped mt-3">
        <thead>
          <tr>
            <th>ID</th>
            <th>{t("email")}</th>
            <th onClick={() => handleSort("firstName")} style={{ cursor: "pointer" }}>
              {t("name")} {sortConfig.key === "firstName" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
            </th>
            <th onClick={() => handleSort("lastName")} style={{ cursor: "pointer" }}>
            {t("surname")} {sortConfig.key === "lastName" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
            </th>
            <th>{t("phone")}</th>
            <th onClick={() => handleSort("role")} style={{ cursor: "pointer" }}>
            {t("role")} {sortConfig.key === "role" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
            </th>
            <th>{t("actions")}</th>
          </tr>
        </thead>
        <tbody>
          {sortedUsers.length > 0 ? (
            sortedUsers.map((user) => (
              <tr 
                key={user.id} 
                className={user.role === "new" ? "table-warning" : ""}
              >
                <td>{user.id}</td>
                <td>{user.email}</td>
                <td>{user.firstName}</td>
                <td>{user.lastName}</td>
                <td>{user.phone}</td>
                <td
                                className={user.role === "admin" ? "table-danger" : ""}
                >{user.role}</td>
                <td>
                <AiOutlineEdit 
                    style={{ cursor: "pointer", marginRight: "10px", color: "orange" }} 
                    size={20} 
                    onClick={() => handleEditClick(user)} 
                  />
                  <AiOutlineDelete 
                    style={{ cursor: "pointer", color: "red" }} 
                    size={20} 
                    onClick={() => handleDeleteUser(user.id)} 
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center">{t("noUsers")}</td>
            </tr>
          )}
        </tbody>
      </table>
      
      {/* Модальне вікно редагування */}
      <Modal show={editModal} onHide={() => setEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{t("edit")} {t("user").toLocaleLowerCase()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>{t("email")}</Form.Label>
              <Form.Control type="email" value={userData.email} onChange={(e) => setUserData({ ...userData, email: e.target.value })} />
              {errors.email && <div className="text-danger">{errors.email}</div>}
            </Form.Group>
            <Form.Group>
              <Form.Label>{t("name")}</Form.Label>
              <Form.Control type="text" value={userData.firstName} onChange={(e) => setUserData({ ...userData, firstName: e.target.value })} />
              {errors.firstName && <div className="text-danger">{errors.firstName}</div>}
            </Form.Group>
            <Form.Group>
              <Form.Label>{t("surname")}</Form.Label>
              <Form.Control type="text" value={userData.lastName} onChange={(e) => setUserData({ ...userData, lastName: e.target.value })} />
              {errors.lastName && <div className="text-danger">{errors.lastName}</div>}
            </Form.Group>
            <Form.Group>
              <Form.Label>{t("phone")}</Form.Label>
              <Form.Control type="text" value={userData.phone} onChange={(e) => setUserData({ ...userData, phone: e.target.value })} />
              {errors.phone && <div className="text-danger">{errors.phone}</div>}
            </Form.Group>
            <Form.Group>
              <Form.Label>{t("role")}</Form.Label>
              <Form.Control as="select" value={userData.role} onChange={(e) => setUserData({ ...userData, role: e.target.value })}>
                <option value="user">{t("user")}</option>
                <option value="admin">{t("admin")}</option>
                <option value="new">{t("new")}</option>
              </Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleUpdate}>
            {t("save")}
          </Button>
          <button className="btn btn-warning" onClick={() => handleResetPassword(selectedUser.id)}>
              {t("resetPassword")}
          </button>

          <Button variant="secondary" onClick={() => setEditModal(false)}>
            {t("close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UsersTab;
